$(document).ready(function () {
    
    $('.quantity-minus').click(function(){
        event.preventDefault();
        
        var elem   = $(this),
            parent = elem.parent(),
            input  = parent.find('input'),
            val    =  Math.floor(input.val()) - 1;

        if( val > 0 ){
            input.val( val );
        }
    });

    $('.quantity-plus').click(function(){
        event.preventDefault();

        var elem   = $(this),
            parent = elem.parent(),
            input  = parent.find('input'),
            val    = Math.floor(input.val()) + 1;

        if( val < 51 ){            
            input.val( val );
        }
    });

    $(document).on('click', '.add-to-cart', function(){

        loader_on();        

        var btn      = $(this),
            elem     = btn.parents('.product, .item'),
            id       = parseInt(elem.data('id')),
            quantity = parseInt(elem.find('.quantity-input').val());

        if(!isNaN(id) && id){
            
            if(!isNaN(quantity) && quantity){
            
                if(quantity > 50){
                    quantity = 50;
                }else if(quantity < 1){
                    quantity = 1;
                }
    
            }else{
                quantity = 1;
            }
    
            var data = {
                'id'       : id,
                'quantity' : quantity
            }

            jQuery.post('/wp-admin/admin-ajax.php', {
                action: 'add_to_cart',
                data: data
            },
            function (res) {                
            
                cart_widget();
                loader_off();
                
                if(!$('body').hasClass('page-template-cart')){
                    $('.mobile-cart-popup-wrapper').show();
                    $('.mobile-cart-popup-wrapper').addClass('show');
    
                    $('.mobile-cart-popup .table').html('');
                    $('.mobile-cart-popup .table').append(res);
                    $('.one-click-content .table').html('');
                    $('.one-click-content .table').append(res);
                }
                
                startMasks();

            });

        }      

    });

    $('.close-cart-popup, .mobile-cart-blackboard').click(function(){
        $('.mobile-cart-popup-wrapper').removeClass('show');
        setTimeout(function(){
            $('.mobile-cart-popup-wrapper').hide();
        }, 700);
    });

});